import { fromJS } from 'immutable'
import { tabChanged } from 'scenes/VehicleDetail/utils'

import { FETCH_NOTIFICATIONS } from './constants'
import { LOCATION_CHANGE } from 'react-router-redux'


export const initialState = fromJS({
  notification_list: []
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case FETCH_NOTIFICATIONS:
      return state.set('notification_list', action.notification_list)
    case LOCATION_CHANGE:
      return tabChanged(action.payload, 'siniestro', state, initialState)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/reducer.js